import { SupportEmailProvider } from "@mcleod/common";
import { LMEGeneralSettings } from "./settings/LMEGeneralSettings";
import { AuthToken, StringUtil } from "@mcleod/core";
import { LMEUserSettings } from "./settings/LMEUserSettings";

export class LMESupportEmailProvider extends SupportEmailProvider{
    public override shouldDisplayPageHeaderSupportEmailLink(): boolean {
        return AuthToken.isAuthenticated() &&
            StringUtil.isEmptyString(LMEGeneralSettings.get()?.pbw_support_email_address) !== true;
    }

    public override getMailToLink(): string {
        return `mailto:${LMEGeneralSettings.get().pbw_support_email_address}?subject=${this.getSupportEmailSubject()}&body=${this.getSupportEmailBody()}`;
    }

    override getSupportEmailSubject(): string {
        const userSettings = LMEUserSettings.get();
        let company = userSettings.company_scac;
        if (StringUtil.isEmptyString(company) === true)
            company = userSettings.company_name;
        return encodeURIComponent("PBW Support Request" + (StringUtil.isEmptyString(company) !== true ? (": " + company) : ""));
    }
}
